export default __webpack_public_path__ + "static/about-us-security1-e8d91500636143d19065ae709fe0b966.jpg";